/* eslint-disable quotes */
/**
 * NOTE: Component will be shown independent of list length, so if there are no elements, hide it from outside
 */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { RecommendationsLayout } from '@beef/smart-kit';

import commonStyles from 'styles/common.pcss';

// import { SmartFrameSwitcher, SmartFrame } from '../SmartFrameSwitcher';

import styles from './styles.pcss';
import { CrossSellDevice } from './Components';

const cx = classNames.bind({ ...commonStyles, ...styles });

/**
 * Stateless adjustable view for CrossSell FrameSwitcher
 */
const CrossSellAdjustable = ({ headline, list, onAddToBasket, src }) => (
  <div className={cx('wrapper')}>
    {list?.length > 0 && (
      <RecommendationsLayout
        captionSize="size3-m"
        label={headline}
        maxSlides={7}
        products={[]}
        devicesStatus="succeeded"
        tabsStatus="succeeded"
      >
        {list.map((product) => (
          <Fragment key={product.name}>
            <CrossSellDevice
              src={src}
              product={product}
              onAddToBasket={() => onAddToBasket(product)}
            />
          </Fragment>
        ))}
      </RecommendationsLayout>
    )}
  </div>
);

CrossSellAdjustable.propTypes = {
  headline: PropTypes.string,
  src: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      article: PropTypes.string,
      detailsSlugOrId: PropTypes.string,
      gtmPrice: PropTypes.bool,
      price: PropTypes.number,
      id: PropTypes.number,
      remain: PropTypes.number,
      maxQuantity: PropTypes.number,
      collectionId: PropTypes.number,
      collectionNameSingular: PropTypes.string,
      brandName: PropTypes.string,
      promotionId: PropTypes.null || PropTypes.number,
      scaleString: PropTypes.null || PropTypes.string,
      isPreorder: PropTypes.bool,
      scale: PropTypes.object,
      image: PropTypes.shape({
        weight: PropTypes.null || PropTypes.number,
        id: PropTypes.string,
        imageUrl: PropTypes.string,
        thumbUrl: PropTypes.string,
        widgetImageUrl: PropTypes.string,
        shopProductId: 0,
      }),
    }),
  ),
  onAddToBasket: PropTypes.func,
};

export default CrossSellAdjustable;
